export default __webpack_public_path__ + "static/media/phone-on-bike.94cace24.jpg";